import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, EMPTY_STRING, LoadingMessages } from "src/app/common/Const";
import { ME200018 } from "src/app/common/const-message-id";
import { GC_D2016_CORR_SLIP } from "src/app/common/ConstCcd";
import { TableColumnDef } from "src/app/common/table-column-def";
import { ReqAccess } from "src/app/request/req-access";
import { Spmt10291DetailCommentDto } from "src/app/request/req-spmt10291-confirm";
import { ReqSpmt10291DetailSearch } from "src/app/request/req-spmt10291-search";
import { Spmt10291DetailSearchRowDto } from "src/app/response/rsp-spmt10291-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { MessageService } from "src/app/service/message.service";

export enum ColumnIds {
  SlipLineNo = "slipLineNo",
  ProductCd = "productCd",
  StandardNm = "standardNm",
  ProductNm = "productNm",
  InStockQty = "inStockQty",
  InCostExc = "inCostExc",
  InCostAmtExc = "inCostAmtExc",
  InSellPriceExc = "inSellPriceExc",
  InSellPriceAmtExc = "inSellPriceAmtExc",
  OutSlipDtlComment = "inSlipDtlComment",
  OutSlipDtlApproverComment = "outSlipDtlApproverComment",
  InSlipDtlApproverComment = "inSlipDtlApproverComment",
  ErrorMessage = "errorMessage",
}

export enum ColumnHeaders {
  SlipLineNo = "伝票行番号",
  ProductCd = "商品コード",
  StandardNm = "規格",
  InStockQty = "入庫数量",
  InCostExc = "入庫原単価(抜)",
  InSellPriceExc = "入庫売単価(抜)",
  OutSlipDtlComment = "出庫店伝票詳細コメント",
  OutSlipDtlApproverComment = "出庫店伝票詳細承認者コメント",
  InSlipDtlApproverComment = "入庫店伝票詳細承認者コメント",
  ErrorMessage = "システムメッセージ",
  ProductNm = "商品名称",
  InCostAmtExc = "入庫原価金額(抜)",
  InSellPriceAmtExc = "入庫売価金額(抜)",
}

interface TableRow extends Spmt10291DetailSearchRowDto {
  errorMessage: string;
  form: {
    inSlipDtlApproverCommentFormCtrl: FormControl;
  };
}
@Component({
  selector: "spmt10291-detail-dialog",
  templateUrl: "./spmt10291-detail-dialog.component.html",
  styleUrls: ["./spmt10291-detail-dialog.component.css"],
})
export class Spmt10291DetailDialogComponent implements OnInit, AfterViewInit {
  columnIdFirst: string[] = [
    ColumnIds.SlipLineNo,
    ColumnIds.ProductCd,
    ColumnIds.StandardNm,
    ColumnIds.InStockQty,
    ColumnIds.InCostExc,
    ColumnIds.InSellPriceExc,
    ColumnIds.OutSlipDtlComment,
    ColumnIds.OutSlipDtlApproverComment,
    ColumnIds.InSlipDtlApproverComment,
    ColumnIds.ErrorMessage,
  ];
  columnIdSecond: string[] = [ColumnIds.ProductNm, ColumnIds.InCostAmtExc, ColumnIds.InSellPriceAmtExc];
  columnDefsItemsFirst: TableColumnDef[] = [
    { columnId: ColumnIds.SlipLineNo, header: ColumnHeaders.SlipLineNo, width: 70, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.ProductCd, header: ColumnHeaders.ProductCd, width: 105, align: Alginment.Left, rowspan: 1 },
    { columnId: ColumnIds.StandardNm, header: ColumnHeaders.StandardNm, width: 85, align: Alginment.Left, rowspan: 1 },
    { columnId: ColumnIds.InStockQty, header: ColumnHeaders.InStockQty, width: 70, align: Alginment.Right, rowspan: 2, numberPipe: "1.0-0" },
    { columnId: ColumnIds.InCostExc, header: ColumnHeaders.InCostExc, width: 100, align: Alginment.Right, rowspan: 1, numberPipe: "1.2-2" },
    { columnId: ColumnIds.InSellPriceExc, header: ColumnHeaders.InSellPriceExc, width: 100, align: Alginment.Right, rowspan: 1, numberPipe: "1.2-2" },
    { columnId: ColumnIds.OutSlipDtlComment, header: ColumnHeaders.OutSlipDtlComment, width: 150, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.OutSlipDtlApproverComment, header: ColumnHeaders.OutSlipDtlApproverComment, width: 150, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.InSlipDtlApproverComment, header: ColumnHeaders.InSlipDtlApproverComment, width: 150, align: Alginment.Left, rowspan: 2, isTextbox: true },
    { columnId: ColumnIds.ErrorMessage, header: ColumnHeaders.ErrorMessage, width: 150, align: Alginment.Left, rowspan: 2, class: "error-message" },
  ];

  columnDefsItemsSecond: TableColumnDef[] = [
    { columnId: ColumnIds.ProductNm, header: ColumnHeaders.ProductNm, width: 190, align: Alginment.Left, rowspan: 1, colspan: 2 },
    { columnId: ColumnIds.InCostAmtExc, header: ColumnHeaders.InCostAmtExc, width: 75, align: Alginment.Right, rowspan: 1, numberPipe: "1.0-0" },
    { columnId: ColumnIds.InSellPriceAmtExc, header: ColumnHeaders.InSellPriceAmtExc, width: 75, align: Alginment.Right, rowspan: 1, numberPipe: "1.0-0" },
  ];

  dataSource: MatTableDataSource<TableRow> = new MatTableDataSource<TableRow>([]);
  itemTableWidth: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private readonly dialogRef: MatDialogRef<Spmt10291DetailDialogComponent>,
    private readonly messages: MessageService,
    private readonly httpBasic: HttpBasicService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      access: ReqAccess;
      isDisableRow: boolean;
      outStoreCd: string;
      outStoreNm: string;
      inStoreCd: string;
      inStoreNm: string;
      systemSlipNo: string;
      slipNo: string;
      updDateTime: string;
      details: Spmt10291DetailCommentDto[];
      redBlackFlg: string;
    },
    public commonService: CommonService
  ) {}
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  get GC_D2016_CORR_SLIP() {
    return GC_D2016_CORR_SLIP;
  }

  private fnSearch() {
    const req: ReqSpmt10291DetailSearch = {
      access: this.data.access,
      systemSlipNo: this.data.systemSlipNo,
      updDateTime: this.data.updDateTime,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10291DetailSearch(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.dataSource.data = res.rows.map((item) => ({
          ...item,
          errorMessage: item.outOfStockFlg ? this.messages.message[ME200018].replace("%1", "出庫数量") : EMPTY_STRING,
          form: {
            inSlipDtlApproverCommentFormCtrl: new FormControl({
              value: this.data.details.find((detail) => detail.systemSlipDetailNo === item.systemSlipDetailNo)?.inSlipDtlApproverComment || item.inSlipDtlApproverComment,
              disabled: this.data.isDisableRow,
            }),
          },
        }));
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  ngOnInit() {
    this.calcTableWidth();
    this.fnSearch();
  }

  calcTableWidth() {
    this.itemTableWidth = { width: "100%" };
  }

  btnConfirmClick(): void {
    const result = this.dataSource.data.map((item) => {
      return {
        systemSlipDetailNo: item.systemSlipDetailNo,
        inSlipDtlApproverComment: item.form.inSlipDtlApproverCommentFormCtrl.value,
      };
    });

    this.dialogRef.close(result);
  }
}
